var CompanyLegacyModule = /** @class */ (function () {
    function CompanyLegacyModule() {
    }
    return CompanyLegacyModule;
}());
export { CompanyLegacyModule };
